'use strict';

angular.module('licensure.services')
    .factory('EnterpriseMergeFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function (code) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/EnterpriseMergeFields', {
                    params: {
                        code: code
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                    });

                return d.promise;
            }
        }
    }])
;